import _taggedTemplateLiteral from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import _slicedToArray from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: 10px 0;\n  font-size: 14px;\n\n  .animalButton button {\n    padding: 0;\n    width: 31px;\n    svg {\n      height: 24px;\n      margin-bottom: -6px;\n    }\n  }\n\n  .saveButton {\n    display: inline-block;\n    margin-right: 0.5rem;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

/**
 * @file Created on Tue Dec 05 2018
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { GridSettings, Utils } from '@logio/common-be-fe';
import { observer } from 'mobx-react';
import * as React from 'react';
import styled from 'styled-components';
import Button, { ButtonColor, ButtonSize } from '../../../controls/Button';
import translate from '../../../i18n/translate';
import Tooltip from '../../../info/Tooltip';
import Icon from '../../../media/Icon';
import GridSettingsModal from './GridSettingsModal';

var GridSettingsBar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(GridSettingsBar, _React$Component);

  function GridSettingsBar() {
    _classCallCheck(this, GridSettingsBar);

    return _possibleConstructorReturn(this, _getPrototypeOf(GridSettingsBar).apply(this, arguments));
  }

  _createClass(GridSettingsBar, [{
    key: "render",
    value: function render() {
      var _this = this;

      return React.createElement(StyledFilterViewBar, null, React.createElement("div", {
        className: "saveButton"
      }, React.createElement(Button, {
        buttonSize: ButtonSize.Tiny,
        buttonColor: ButtonColor.Light,
        onClick: this.props.store.gridSettingModalNew
      }, translate('Save view')), React.createElement(Button, {
        buttonSize: ButtonSize.Tiny,
        buttonColor: ButtonColor.Light,
        onClick: this.props.store.gridSettingReset
      }, translate('Default view'))), Array.from(this.props.store.gridSettings).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            _ = _ref2[0],
            gridSetting = _ref2[1];

        return React.createElement(Tooltip, {
          key: gridSetting.id,
          overlay: React.createElement("div", null, gridSetting.name),
          children: React.createElement("div", {
            className: "animalButton"
          }, React.createElement(Button, {
            buttonColor: ButtonColor.Outline,
            buttonSize: ButtonSize.Tiny,
            onClick: function onClick() {
              return _this.props.store.activeGridSettingsId === gridSetting.id ? _this.props.store.gridSettingModalEdit(gridSetting.id) : _this.props.store.gridSettingSwitch(gridSetting.id);
            },
            title: gridSetting.name,
            isActive: _this.props.store.activeGridSettingsId === gridSetting.id
          }, React.createElement(Icon, {
            iconType: gridSetting.icon,
            iconHeight: 24
          }))),
          placement: 'top'
        });
      }), this.props.store.gridSettingsModalVisible && React.createElement(GridSettingsModal, {
        gridSetting: this.props.store.activeGridSettingsId != null ? this.props.store.gridSettings.get(this.props.store.activeGridSettingsId) : new GridSettings(Utils.VOID_ID, null, Utils.VOID_ID, this.props.store.gridId, null, null, false, {
          columnState: this.props.store.gridColumnApi.getColumnState(),
          filterModel: this.props.store.gridApi.getFilterModel(),
          sortModel: this.props.store.gridApi.getSortModel()
        }),
        hidden: !this.props.store.gridSettingsModalVisible,
        onClose: this.props.store.toggleGridSettingModalVisible,
        onSubmit: this.props.store.gridSettingModalSubmit,
        onDelete: this.props.store.activeGridSettingsId != null ? function () {
          return _this.props.store.gridSettingDelete(_this.props.store.activeGridSettingsId);
        } : null
      }));
    }
  }]);

  return GridSettingsBar;
}(React.Component);

GridSettingsBar = __decorate([observer], GridSettingsBar);
export default GridSettingsBar;
var StyledFilterViewBar = styled.div(_templateObject());